/* CUSTOM CODE Treatment */
(function ($, window) {
    const mq = window.matchMedia("(max-width: 575px)");
    let customScrollInstance;
    let updateSliderPositionTimeoutId;
    let moveTolstoyAndSliderTimeoutId;

    /**
     * Handle DOM
     */
    function handleDOM() {
        // Moving product title
        if ($(".kingpalm_product_summary").length !== 0 && $(".product_title").length !== 0) {
            $(".kingpalm_product_summary").prepend($(".product_title"));
        }

        // Moving price
        if ($(".kingpalm_product_summary").length !== 0 && $(".title-price").length !== 0 && $(".title-price .price").length !== 0) {
            const priceWrapper = `<div class="price-wrapper"><span class="price-cost">Cost:</span></div>`;
            $(priceWrapper).insertAfter($(".product_title"));
            $(".price-wrapper").append($(".title-price .price"));
            $(".title-price").remove();
        }

        // Inserting stars
        if ($(".kingpalm_product_summary").length !== 0 && $(".kingpalm_product_summary .stock").length !== 0 && $(".price-wrapper").length !== 0 && $("#kp_prod_ab_stars").length !== 0) {
            const availablilityRatingWrapper = `<div class="availability-rating"></div>`;
            $(availablilityRatingWrapper).insertAfter($(".price-wrapper"));
            $(".availability-rating").append($(".kingpalm_product_summary .stock"));
            $(".availability-rating").append($("#kp_prod_ab_stars").html());
        }

        // Changing the Add To Cart button text
        if ($("form.cart").length !== 0 && $("#kp_prod_ab_add_to_cart_text").length !== 0) {
            const addToCartText = $("#kp_prod_ab_add_to_cart_text").html();
            $("form.cart button[type='submit']").html(addToCartText);
        }

        // Adding qualifies block
        if ($("form.cart").length !== 0 && $("#kp_prod_qualifies").length !== 0) {
            const qualifiesBlock = $("#kp_prod_qualifies").html();
            $("form.cart button[type='submit']").wrapAll(`<div class="button-and-qualifies-wrapper" ></div>`);
            $(".button-and-qualifies-wrapper").append(qualifiesBlock);
        }
    }

    /**
     * Moving tolstoy and recommended for you slider
     */
    function moveTolstoyAndRecommendedForYouSlider(is_max_width_575) {
        clearTimeout(moveTolstoyAndSliderTimeoutId);

        if (is_max_width_575) {
            moveTolstoyAndSliderTimeoutId = setTimeout(function () {
                // Moving the recommended for you slider before the yotpo-shoppers-say
                if ($(".custom-related-Slider").length !== 0 && $(".yotpo-shoppers-say").length !== 0) {
                    const customRelatedSlider = $(".custom-related-Slider");
                    $(".yotpo-shoppers-say").before(customRelatedSlider);
                } else if ($(".custom-related-Slider").length !== 0 && $(".yotpo-shoppers-say").length === 0 && $("form.cart button[type='submit']").length !== 0) {
                    const customRelatedSlider = $(".custom-related-Slider");
                    $("form.cart").after(customRelatedSlider);
                }

                // Moving tolstoy stories after the cart form
                if ($("form.cart").length !== 0 && $(".tolstoy-stories").length !== 0) {
                    $("form.cart").after($(".tolstoy-stories"));
                }

                clearTimeout(moveTolstoyAndSliderTimeoutId);
            }, 500);
        } else {
            moveTolstoyAndSliderTimeoutId = setTimeout(function () {
                // Moving the recommended for you slider after the .ab-product block
                if ($(".custom-related-Slider").length !== 0 && $(".ab-product").length !== 0) {
                    const customRelatedSlider = $(".custom-related-Slider");
                    $(".ab-product").after(customRelatedSlider);
                }

                // Moving tolstoy stories after the tolstoy stories
                if ($(".ab-product").length !== 0 && $(".tolstoy-stories").length !== 0) {
                    $(".ab-product").after($(".tolstoy-stories"));
                }

                clearTimeout(moveTolstoyAndSliderTimeoutId);
            }, 500);
        }

    }

    /**
     * Previews slider
     */
    function previewsSlider(is_max_width_575 = false) {
        const blockHTML = $("#kp_prod_gallery_wrapper").html();
        let containerWidth = $(".site-main > .container").outerWidth();
        $(":root")[0].style.setProperty("--preview-slide-width", `${containerWidth}px`);

        $(window).on("resize", function () {
            containerWidth = $(".site-main > .container").outerWidth();
            $(":root")[0].style.setProperty("--preview-slide-width", `${containerWidth}px`);
        });

        $(".holder-slider-product").empty();
        $(".holder-slider-product").append(blockHTML);

        $("#ab-carousel").flexslider({
            selector: ".woocommerce-product-gallery-miniatures__wrapper > li",
            animation: "slide",
            controlNav: false,
            directionNav: false,
            animationLoop: false,
            animationSpeed: 150,
            touch: true,
            itemWidth: 210,
            itemMargin: 11,
            minItems: is_max_width_575 ? 5 : 8,
            maxItems: is_max_width_575 ? 5 : 8,
            slideshow: true,
            asNavFor: "#ab-slides",
        });

        $("#ab-slides").flexslider({
            selector: ".woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image",
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            animationSpeed: 150,
            touch: true,
            slideshow: true,
            sync: "#ab-carousel",
            after: function (slider) {
                if (slider.currentSlide === 0) {
                    $("#ab-carousel").flexslider(0); // Go to the first slide in the synced slider
                }
            }
        });
    }

    /**
     * Updating the Recommended for you slider
     */
    function updateRecommendedForYouSlider() {
        const recommendedSlider = $(".custom-related-Slider .slider .swiper-container")[0];
        if (recommendedSlider.swiper) {
            const swiperInstance = recommendedSlider.swiper;
            swiperInstance.params.breakpoints = {
                320: {
                    slidesPerView: 3,
                    spaceBetween: 8,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
            };
            swiperInstance.update();
        } else {
            setTimeout(function () {
                const recommendedSlider = $(".custom-related-Slider .slider .swiper-container")[0];
                if (recommendedSlider.swiper) {
                    const swiperInstance = recommendedSlider.swiper;
                    swiperInstance.params.breakpoints = {
                        320: {
                            slidesPerView: 3,
                            spaceBetween: 8,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                        },
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 15,
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 40,
                        },
                    };
                    swiperInstance.update();
                }
            }, 2000);
        }
    }

    /**
     * List category (flavors) custom scroll
     */
    // function listCategoryCustomScroll() {
    //     if (customScrollInstance) {
    //         customScrollInstance.destroy();
    //         customScrollInstance = null;
    //     }

    //     if ($(".ab-flavor-options-wrapper").length === 0) {
    //         $(".select-category .list-category.ab-flavor-options").wrapAll(`<div class="ab-flavor-options-wrapper" ></div>`);
    //     }

    //     customScrollInstance = $(".ab-flavor-options-wrapper").overlayScrollbars({
    //         className: "os-theme-dark",
    //         resize: "none",
    //         sizeAutoCapable: true,
    //         paddingAbsolute: true,
    //         scrollbars: {
    //             clickScrolling: true,
    //             visibility: "auto",
    //             autoHide: "never"
    //         }
    //     }).overlayScrollbars();
    // }
    $(document).ready(function () {
        productFeaturesSlider();
        $('.btn-zoom').on('click', function () {
            $('.gallery-popup').trigger('click');
        });




    });
    $(window).on("resize orientationchange", function () {
        // moveTolstoyAndRecommendedForYouSlider(mq.matches);
        variationsSlider();
        productFeaturesSlider();

        if (mq.matches && customScrollInstance) {
            customScrollInstance.destroy();
            customScrollInstance = null;
        } else {
            if (!customScrollInstance) {
                // listCategoryCustomScroll();
            }
        }
    });

    /**
     * Product features slider
     */
    function productFeaturesSlider() {
        const $carousel = $(".product-image-block-features");

        if ($carousel.length !== 0) {
            $carousel.css('display', 'flex');

            const sliderOptions = {
                slidesToShow: 1,
                useTransform: false,
                speed: 300,
                autoplay: true,
                arrows: true,
                prevArrow: `<button type="button" class="arrow-prev"><</button>`,
                nextArrow: `<button type="button" class="arrow-next">></button>`,
                dots: false,
                mobileFirst: true,
            };

            if (!$carousel.hasClass('slick-initialized')) {
                $carousel.slick(sliderOptions);
            }
        }
    }

    /**
     * Variations slider
     */
    function variationsSlider() {
        // Active index - to show appropriate slide as first
        const activeVariationIndex = $(".ab-flavor-options .ab-flavor-option.active").index();
        const variationsQuantity = $(".ab-flavor-options .ab-flavor-option").length;
        const slidesToDisplay = 7;

        if (variationsQuantity <= slidesToDisplay) {
            return;
        }

        const $carousel = $(".ab-flavor-options");

        if ($carousel.length !== 0) {
            const sliderOptions = {
                arrows: true,
                prevArrow: `<button type="button" class="slider-arrow slider-arrow_prev" aria-label="Prev slide">
					<svg width="4" height="7" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M0 3.36621L3.75 6.3973L3.75 0.335122L0 3.36621Z" fill="#9A9A9A"></path>
					</svg>
				</button>`,
                nextArrow: `<button type="button" class="slider-arrow slider-arrow_next" aria-label="Next slide">
					<svg width="4" height="6" viewBox="0 0 4 6" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M4 2.86621L0.25 5.46429L0.25 0.268135L4 2.86621Z" fill="#9A9A9A"></path>
					</svg>
				</button>`,
                slidesToShow: slidesToDisplay,
                speed: 100,
                cssEase: "ease-out",
                useTransform: false,
                swipeToSlide: true,
                initialSlide: activeVariationIndex,
            };

            clearTimeout(updateSliderPositionTimeoutId);

            if ($(window).width() > 575) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else {
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick(sliderOptions);

                    updateSliderPositionTimeoutId = setTimeout(function () {
                        $(".ab-flavor-options.slick-initialized").slick("refresh");

                        clearTimeout(updateSliderPositionTimeoutId);
                    }, 300);
                }
            }
        }
    }

    try { productFeaturesSlider(); } catch (err) { console.log(err); }

    function init() {
        try { handleDOM(); } catch (err) { console.log(err); }
        // try { moveTolstoyAndRecommendedForYouSlider(mq.matches); } catch (err) { console.log(err); }
        try { previewsSlider(mq.matches); } catch (err) { console.log(err); }
        try { variationsSlider(); } catch (err) { console.log(err); }
        // try { listCategoryCustomScroll(); } catch (err) { console.log(err); }
        try { updateRecommendedForYouSlider(); } catch (err) { console.log(err); }
    }

    init();

})(jQuery, window);
